import React from 'react';
import {
  ExtractIcon,
} from '../Styled/Buttons/icons';
import SubPage from '../MaterialUI/subpage';
import meta from '../../const/meta';

const items = [
  {
    url: meta.doc.household.frontend,
    title: 'Облікові картки об\'єктів погосподарського обліку',
    icon: ExtractIcon,
    section: 'household',
    desc: 'Облікова картка об\'єкта погосподарського обліку',
  },
  {
    url: meta.cat.householdMembers.frontend,
    title: 'Фізичні особи',
    icon: ExtractIcon,
    section: 'household',
    desc: 'Фізичні особи',
  },

];
function HouseholdPage() {
  return <SubPage pageTitle="Домогосподарства" items={items} />;
}

export default HouseholdPage;
